import _ from 'lodash';
import { ReactNode, useState } from 'react';
import { AnimatedViewContext, IAnimatedViewContext } from './context';

interface IAnimatedViewContextProviderProps<T> {
  defaultView: T;
  children: ReactNode | ((props: IAnimatedViewContext<T>) => ReactNode);
  onChange?: (view: T) => void;
}

export const AnimatedViewContextProvider = <T,>({
  defaultView,
  children,
  onChange,
}: IAnimatedViewContextProviderProps<T>) => {
  const [stack, setStack] = useState<T[]>([defaultView]);

  const back = () => {
    setStack((prev) => {
      if (prev.length === 1) {
        onChange?.(prev[0]);
        return prev;
      }
      onChange?.(prev.at(-2));
      return prev.slice(0, -1);
    });
  };

  const push = (view: T) => {
    onChange?.(view);
    setStack((prev) => [...prev, view]);
  };

  const contextValue: IAnimatedViewContext<T> = {
    back,
    current: _.last(stack),
    push,
  };

  return (
    <AnimatedViewContext.Provider value={contextValue}>
      {_.isFunction(children) ? children(contextValue) : children}
    </AnimatedViewContext.Provider>
  );
};
